import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getRelatedPersonRows } from "./related-person-rows";

export const metadata = {
  tableType: "RelatedPerson",
  displayName: "Related Persons",
  getRows: (bundle: FhirBundleSdk) => getRelatedPersonRows({ bundle }),
};
